export default {
  apiKey: "AIzaSyCvHEY47KR8K1xM8OOk-_YObPpHu8tHhGI",
  authDomain: "urofarrera.firebaseapp.com",
  projectId: "urofarrera",
  storageBucket: "urofarrera.appspot.com",
  messagingSenderId: "298910641283",
  appId: "1:298910641283:web:b1ceeee5f0a014cdfe3fb6",
  measurementId: "G-9C4GCTZF55"
}